<template>
  <div v-if="projectData != null">
    <!-- edit componenets -->
    <router-view></router-view>
    <b-container fluid>
      <!-- ############################ PROJECT TITLE ##############################-->
      <b-row :no-gutters="true">
        <b-col sm="12">
          <!--FIRST ROW TITLE NAME plus edit and add icons-->
          <b-list-group :flush="true">
            <!--When using the prop :to remember that it wont work if you have the button prop in there -->
            <b-list-group-item
              :to="{ name: 'projectEdit' }"
              variant="primary"
              :flush="true"
              style="font-weight: bold "
            >
              {{ projectData.projectName }}
              <font-awesome-icon
                icon="edit"
                size="lg"
                style="float:right"
              ></font-awesome-icon>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <!--Project Data -->
      <b-row :no-gutters="true">
        <b-col sm="8">
          <b-list-group :flush="true">
            <b-list-group-item>
              Start Date
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group :flush="true">
            <b-list-group-item>
              <input
                id="non-edit-date"
                type="date"
                v-model="this.projectData.startDate"
                :disabled="true"
              />
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row :no-gutters="true">
        <b-col sm="8">
          <b-list-group :flush="true">
            <b-list-group-item>
              End Date
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group :flush="true">
            <b-list-group-item>
              <input
                id="non-edit-date"
                type="date"
                v-model="this.projectData.endDate"
                :disabled="true"
              />
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row :no-gutters="true">
        <b-col sm="8">
          <b-list-group :flush="true">
            <b-list-group-item>
              Funding comes from
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group :flush="true">
            <b-list-group-item>
              {{ projectData.customer }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row :no-gutters="true">
        <b-col sm="8">
          <b-list-group :flush="true">
            <b-list-group-item>
              Project Type
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group :flush="true">
            <b-list-group-item>
              {{ projectData.typeOfProject }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <!--###############################PROJECT ALIAS#####################################-->
      <b-row :no-gutters="true">
        <b-col sm="12">
          <b-list-group :flush="true">
            <b-list-group-item
              :to="{ name: 'projectAlias' }"
              v-b-modal.alias-crud
              variant="primary"
              :flush="true"
              style="font-weight: bold"
            >
              People sign into this project with one of these names
              <font-awesome-icon
                icon="plus"
                size="lg"
                style="float:right"
              ></font-awesome-icon>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row v-for="item in projectData.aliases" :key="item.id">
        <b-col sm="12">
          <b-list-group :flush="true">
            <b-list-group-item>
              {{ item.aliasName }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row :no-gutters="true">
        <b-col sm="12">
          <!-- ################################Project Outcomes################################-->

          <b-list-group :flush="true">
            <b-list-group-item
              :to="{name:'projectOutcome'}"
              v-b-modal.outcome-crud
              variant="primary"
              :flush="true"
              style="font-weight: bold "
            >
              Outcomes for this project

              <font-awesome-icon
                icon="plus"
                size="lg"
                style="float:right"
              ></font-awesome-icon>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row v-for="(outcome, i) in projectData.outcomes" :key="i.id">
        <b-col sm="12">
          <b-list-group :flush="true">
            <b-list-group-item>
              {{ outcome.outcome }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    // get the project id
    id() {
      // get the project id from i/c route
      return this.$route.params.id;
    },
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
    projectData() {
      return this.$store.getters.project;
    }
  },

  created() {
    // call api in store to populate project object
    // this.$store.dispatch("person", { id: this.id, urlPrefix: this.urlPrefix });
    this.$store.dispatch("genericGetApiCall", {
      mutationName: "project",
      url: this.urlPrefix + "api/project/" + this.id +'/'
    });
  },

  // So if search component is used it wont re-render the page as are already on it
  // but the computed function will change the id (last part of url)
  // the watch will call the function to refresh the data when that happens
  watch: {
    // id: function() {
    //   //alert('id changed')
    //   // this.$store.dispatch("person", {
    //   //   id: this.id,
    //   //   urlPrefix: this.urlPrefix
    //   // });
    //   this.$store.dispatch("genericGetApiCall", {
    //     mutationName: "person",
    //     url: this.urlPrefix + "api/person/" + this.id
    //   });
    // }
  },
  methods: {
    navigate() {
      //eslint-disable-next-line no-console
      //console.log('in nave method');
      this.$router.push({ name: "editProject" });
    }
  }
};
</script>

<style scoped>
#non-edit-date {
  border-width: 0px;
  border: none;
}
</style>
